import { useState, lazy, Suspense, memo } from 'react';
import Header from '../../components/Header/Header';
import { usePopupsContext } from '../../components/Popups/Popups';
import './Home2.css';
import ChoosePlanUnlock from '../../components/ChoosePlan/ChoosePlanUnlock';
import { Link } from 'react-router-dom';
import { Config } from "@cleeng/mediastore-sdk";

const ExclusiveContent = lazy(() => import('../../components/ExclusiveContent/ExclusiveContent'));
const Lineup = lazy(() => import('../../components/Lineup/Lineup'));
const StarsShows = lazy(() => import('../../components/StarsShows/StarsShows'));
const Accessibility = lazy(() => import('../../components/Accessibility/Accessibility'));
const FAQs = lazy(() => import('../../components/FAQs/Faqs'));
const FooterLinks = lazy(() => import('../../components/Footer/FooterLinks'));

const HomePage = () => {
    const { showModal } = usePopupsContext();
    const [isGiftMode, setIsGiftMode] = useState(false);
    Config.setTermsUrl('https://www.newsmax.com/termsconditions/?utm_source=nmplus&utm_medium=footer');

    return (
        <>
            <Header isHomePage />

            <div id="watch">

                <div id="hero" className="hero d-flex d-lg-none header-img-bkgd">
                    <div className="top-0 start-0 w-100 h-100 zindex-1 bg-black bg-opacity-50"></div>
                    <div className="row position-absolute text-white zindex-2 m-0">
                        <h1 className="fw-bolder">Unlock Full Access to Newsmax+</h1>
                        <h2 className="fw-bold">One Subscription. Everything Newsmax Has to Offer.</h2>
                        <Link className='nm-btn w-auto shadow-md rounded' to="/checkout/annually">Start Your FREE Trial Now!</Link>
                    </div>
                </div>

                <div className="hero-section d-none d-lg-block">
                    <div className="content-overlay header-img-bkgd">
                        <div className="container text-white text-center">
                            <h1>Unlock Full Access to Newsmax</h1>
                            <h2 className="mb-4 mb-sm-0">One Subscription. Everything Newsmax Has to Offer.</h2>
                            <br className="d-none d-sm-block" />
                            <Link className='nm-btn w-auto shadow-md rounded' to="/checkout/annually">Start Your FREE Trial Now!</Link>
                        </div>
                    </div>
                </div>

                <section id="start-watching" className="py-3 py-sm-5">
                    <div className="container">
                        <div className="row text-center py-5">
                            <h2 className="my-2 fw-bold">Start Watching Newsmax+ Today!</h2>
                            <h3 className="my-2 fw-medium">Claim Your FREE Trial . . .</h3>
                            <Link className='nm-btn w-auto py-2 px-5 text-white bg-accent shadow-md rounded' to="/checkout/annually">Start Your FREE Trial</Link>
                        </div>
                    </div>
                </section>

                <Suspense fallback={null}>
                    <ExclusiveContent isGiftMode={isGiftMode} showModal={showModal} />
                </Suspense>

                <Suspense fallback={null}>
                    <Lineup isGiftMode={isGiftMode} showModal={showModal} />
                </Suspense>

                <section id="full-access" className=" bg-blue py-4 py-sm-5">
                    <div className="container">
                        <div className="row text-center">
                            <h2 className="display-4 my-2 fw-bold text-white text-shadow">Full Access to Bonus Channels</h2>
                        </div>
                    </div>
                </section>

                <Suspense fallback={null}>
                    <StarsShows isGiftMode={isGiftMode} showModal={showModal} />
                </Suspense>

                <section id="newsmax2" className="bg-blue">
                    <div className="container-fluid pt-5">
                        <div className="row">
                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center pe-0">
                                <div className="col-8 col-lg-3 offset-lg-1 text-center text-lg-start text-white pb-4">
                                    <img src="/images/logos/nmx2-white-logo.webp" alt="Newsmax2 Logo" className="img-fluid w-100 mb-3" loading="lazy" />
                                    <h4 className="fw-semibold">Stream Newsmax2 Today!</h4>
                                </div>
                                <div className="col-12 col-lg-8">
                                    <img src="/images/hosts/nmx2-streamline-hosts.webp" alt="Newsmax2 Hosts" className="img-fluid w-100" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ChoosePlanUnlock isGiftMode={isGiftMode} showModal={showModal} />

                <section id="WaW" className="py-4 py-sm-5">
                    <div className="container-fluid py-4">
                        <div className="row">
                            <div className="d-flex flex-column flex-md-row justify-content-around align-items-center">
                                <div className="col-8 col-md-5 text-center mb-5 mb-md-3">
                                    <img src="/images/logos/world-at-war-logo.webp" alt="World at War Logo" className="waw-logo img-fluid w-100 mb-4 d-block" loading="lazy" />
                                    <span className="fs-4 text-white fw-semibold ">A Military History Channel</span>
                                </div>
                                <div className="col-12 col-md-6 offset-md-0">
                                    <img src="/images/devices/world-at-war-tv-glow.webp" alt="World at War TV Channel" className="img-fluid w-100" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Suspense fallback={null}>
                    <Accessibility />
                </Suspense>

                <section id="no-commits" className="bg-blue py-3 py-sm-5">
                    <div className="container-fluid py-4 py-sm-5">
                        <div className="row">
                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center">
                                <div className="col-12 col-lg-6 offset-lg-1 text-center text-lg-start text-white px-3 px-lg-0">
                                    <h2 className="mb-3 fw-bolder">No Commitments and Affordable Pricing</h2>
                                    <p className="">Enjoy the freedom of no long-term commitments. Our subscription is flexible, allowing you to cancel anytime if you choose to do so. We offer competitive pricing options that fit every budget. Just $4.99 per month or get an entire year for only $49.99 ( Best Value - Save 16% )</p>
                                </div>
                                <div className="col-12 col-lg-4 text-center">
                                    <Link className='nm-btn w-auto py-2 px-5 text-white bg-accent shadow-md rounded mb-4 mb-lg-0 mx-auto mx-lg-4' to="/checkout/annually">Start Your FREE Trial</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Suspense fallback={null}>
                    <FAQs />
                </Suspense>

                <Suspense fallback={null}>
                    <FooterLinks />
                </Suspense>

                <div id="subStrip" className="sub-strip bg-blue py-2 py-lg-4">
                    <div className="container">
                        <div className="row">
                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center text-white text-center text-lg-start">
                                <p className="mx-auto mx-lg-0 p-0 mb-3 mb-lg-0 flex-grow px-4 px-lg-0">
                                    Subscribe to Newsmax+ today! Start your free trial.
                                </p>
                                <Link className='nm-btn footer-btn w-auto py-2 px-5 text-white bg-accent shadow-md rounded mx-auto mx-lg-0 my-0' to="/checkout/annually">Start Your FREE Trial</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default memo(HomePage);
